import styled from "styled-components";

interface StyledDialogMainProps {
  $size: "large" | "medium" | "small";
  $state: "info" | "success" | "warning" | "error";
}

export const StyledDialogMain = styled.main<StyledDialogMainProps>`
  background: transparent;
  box-sizing: border-box;
  width: 100%;
  padding: ${({ $size }) =>
    $size === "large"
      ? "2.4rem 4rem 6.4rem 4rem"
      : "2.4rem 3.2rem 5.2rem 3.2rem"};
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  gap: 1.2rem;
  justify-content: center;
`;
